var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('v-card',[_c('v-card-title',[_vm._v(" Damaged - "+_vm._s(_vm.article.sku)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }